module.exports = __webpack_public_path__ + "static/media/globe2.9da08b5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/globe2.png
// module id = 1053
// module chunks = 0